var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2533_84391)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.18827 14.8936H13.8095C14.9979 14.8936 15.7387 13.6049 15.1445 12.5786L9.33387 2.53926C8.73969 1.51295 7.2581 1.51295 6.66392 2.53926L0.853297 12.5786C0.259117 13.6049 0.999913 14.8936 2.18827 14.8936ZM7.99889 9.49194C7.57448 9.49194 7.22723 9.14469 7.22723 8.72028V7.17695C7.22723 6.75254 7.57448 6.40529 7.99889 6.40529C8.42331 6.40529 8.77055 6.75254 8.77055 7.17695V8.72028C8.77055 9.14469 8.42331 9.49194 7.99889 9.49194ZM8.77055 12.5786H7.22723V11.0353H8.77055V12.5786Z",
    fill: "#1B51A7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2533_84391"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningBlue);
export default __webpack_public_path__ + "static/media/warning_blue.2dd015bc1d4cc4d7d413ccc4775df5d0.svg";
export { ForwardRef as ReactComponent };